import PropTypes from 'prop-types'
import './ProgressRing.css'

const props = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  inverted: PropTypes.bool,
  animated: PropTypes.bool,
  progress: PropTypes.number.isRequired,
  offset: PropTypes.number,
  size: PropTypes.string,
  content: PropTypes.node
};

export default function ProgressRing({
  backgroundColor = '#F2F2F2',
  color = '#269F00',
  inverted = false,
  animated = false,
  progress = 0,
  offset = 0.5,
  size = '20px',
  content=''
}) {

  const progressAngle = progress*360+'deg';
  const offsetAngle = offset*360+'deg';

  const style = {
    '--progress': progressAngle,
    '--offset': offsetAngle,
    '--progress-size': size,
    '--progress-color': color,
    '--progress-color-bg': backgroundColor
  }

  return (
    <div className='tw-w-full'>
      <div 
      className={ ['cmp-progress-ring', inverted && 'inverted', animated && 'animated'].join(' ') }
      style={style}>
        <div className='cmp-progress-ring_dots'></div>
        <div className='cmp-progress-ring_dots'></div>
        <div className='cmp-progress-ring_inner'>{content}</div>
      </div>
    </div>
  )
}

ProgressRing.propTypes = props
